export default {
  title: {
    en: 'Oops... Something went wrong',
    // eslint-disable-next-line quotes
    fr: "Oups... Quelque chose s'est mal passé",
    it: 'Oops... Qualcosa è andato storto',
    nl: 'Oeps... Er is iets misgegaan'
  },

  retry: {
    en: 'Please try again later.',
    fr: 'Veuillez réessayer plus tard.',
    it: 'Per favore riprova più tardi.',
    nl: 'Probeer het later opnieuw.'
  }
};
